import React, { useEffect } from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { SocialProof } from '../components/landing/SocialProof';
import { WhoIsForSection } from '../components/landing/WhoIsForSection';
import { MechanismSection } from '../components/landing/MechanismSection';
import { CredibilitySection } from '../components/landing/CredibilitySection';
import { BenefitsSection } from '../components/landing/BenefitsSection';
import { BonusSection } from '../components/landing/BonusSection';
import { ReviewsSection } from '../components/landing/ReviewsSection';
import { ValueStackSection } from '../components/landing/ValueStackSection';
import { ObjectionsSection } from '../components/landing/ObjectionsSection';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { FAQSection } from '../components/landing/FAQSection';
import { ClosingSection } from '../components/landing/ClosingSection';
import { Footer } from '../components/landing/Footer';
import { StickyMobileCTA } from '../components/landing/StickyMobileCTA';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  const {
    trackEvent
  } = useMetaPixel();
  useEffect(() => {
    document.documentElement.lang = 'es';
  }, []);
  return <div className="min-h-screen bg-cream text-navy font-sans selection:bg-gold/30 selection:text-navy" data-id="element-496">
      {/* Sticky Navbar */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-navy/95 backdrop-blur-md border-b border-white/10" data-id="element-497">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-498">
          <span className="text-gold font-serif font-bold tracking-widest text-sm md:text-base uppercase" data-id="element-499">
            EL AZÚCAR SILENCIOSO
          </span>

          <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('AddToCart')} data-id="element-500">
            <button className="bg-cta hover:bg-cta-hover text-white font-bold text-xs md:text-sm py-2 px-4 rounded transition-colors shadow-sm" data-id="element-501">
              DESCARGA EBOOK + 3 BONOS — $17.95
            </button>
          </a>
        </div>
      </header>

      <main data-id="element-502">
        <HeroSection data-id="element-503" />
        <SocialProof data-id="element-504" />
        <WhoIsForSection data-id="element-505" />
        <MechanismSection data-id="element-506" />
        <CredibilitySection data-id="element-507" />
        <BenefitsSection data-id="element-508" />
        <BonusSection data-id="element-509" />
        <ReviewsSection data-id="element-510" />
        <ValueStackSection onAddToCart={() => trackEvent('AddToCart')} data-id="element-511" />
        <ObjectionsSection data-id="element-512" />
        <HowItWorksSection data-id="element-513" />
        <FAQSection data-id="element-514" />
        <ClosingSection onAddToCart={() => trackEvent('AddToCart')} data-id="element-515" />
      </main>

      <Footer data-id="element-516" />
      <StickyMobileCTA data-id="element-517" />
    </div>;
}